import environment from '#/environment/environment';
import * as braze from '@braze/web-sdk';

export const initializeBraze = () => {
  braze.initialize(environment.brazeApiKey, {
    baseUrl: environment.brazeBaseUrl,
  });

  braze.openSession();
};
